import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import Layout from "../../Layout";
import Grid from "@mui/material/Grid";
import instance from "../../axios";
import Table from "../../Components/common/tableWithBackEndPagination";
import Loader from "../../Layout/Loader";
import TextField from "../../Components/common/TextField";
import Button from "../../Components/common/Button";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import withTranslationWrapper from "../../HOC/withTranslation";
import AddPaymentForm from "./AddPaymentForm";
import { checkPrivileges } from "../../Helpers";
import { printCustomerReceivingPdf } from "../../Components/Documents";
const CancelToken = axios.CancelToken;
let source;

class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initFetch: false,
      currentPage: 1,
      pagesize: 20,
      loader: false,
      paymentNumber: "",
      refNumber: "",
      from: "",
      to: "",
      mode: "",
      itemPagination: {
        items: [],
        total: 0,
        currentPage: 0,
        hasNext: true,
        searchText: "",
      },
    };
  }

  componentWillUnmount() {
    if (source) source.cancel();
  }

  componentWillMount() {
    if (
      this.props.logInUser &&
      this.props.logInUser.id &&
      this.state.initFetch === false
    ) {
      this.setState({ initFetch: true }, () => {
        this.fetchData(1, this.state.pagesize);
      });
    }
  }

  componentWillReceiveProps(n) {
    if (n.logInUser && n.logInUser.id && this.state.initFetch === false) {
      this.setState({ initFetch: true }, () => {
        this.fetchData(1, this.state.pagesize);
      });
    }
  }

  openCreateForm = () => {
    this.setState({ mode: "create" });
  };

  closeForm = () => {
    this.setState({ mode: "" }, () => {
      this.fetchData(1, this.state.pagesize);
    });
  };

  handleCreateSuccess = () => {
    this.props.dispatch(notifySuccess("paymentCreated"));
    this.closeForm();
  };

  submitSideBarSearch = (data) => {
    this.setState(
      {
        from: data?.from || "",
        to: data?.to || "",
        currentPage: 1,
      },
      () => {
        this.fetchData(1, this.state.pagesize);
      },
    );
  };

  downloadInvoice = (data, type) => {
    this.setState(
      {
        from: data?.from || "",
        to: data?.to || "",
      },
      () => {
        this.downloadPayments(type);
      },
    );
  };

  downloadPayments = (type) => {
    const cn =
      this.props.ServerSetting?.contractNumber ||
      this.props.logInUser?.contractNumber ||
      "";
    const accept =
      type === "downloadPdf"
        ? "application/pdf"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: accept,
    });

    const from = this.state.from ? `&from=${this.state.from}` : "";
    const to = this.state.to ? `&to=${this.state.to}` : "";
    const contractNumber = cn ? `&cn=${encodeURIComponent(cn)}` : "";

    fetch(`/api/payments/export?${to}${from}${contractNumber}`, {
      method: "GET",
      headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Export failed");
        }
        return response.blob();
      })
      .then((blob) => {
        const fileName =
          type === "downloadPdf" ? "Payments.pdf" : "Payments.xlsx";
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
          return;
        }
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch(() => {
        this.props.dispatch(notifyError("somethingWentWrong"));
      });
  };

  fetchData = (page, perPage) => {
    if (source) source.cancel();
    source = CancelToken.source();

    const contractType = this.props.ServerSetting?.contractType || 1;
    const cn =
      this.props.ServerSetting?.contractNumber ||
      this.props.logInUser?.contractNumber ||
      "";
    const { paymentNumber, refNumber, from, to } = this.state;

    let url = `/api/payments/get?`;
    if (to) url += `&to=${to}`;
    if (from) url += `&from=${from}`;
    // if (cn) url += `&cn=${encodeURIComponent(cn)}`;
    url += `&page=${page}&limit=${perPage}&paymentNumber=${encodeURIComponent(
      paymentNumber || "",
    )}&refNumber=${encodeURIComponent(refNumber || "")}`;

    this.setState({ loader: true });
    instance({
      method: "GET",
      url,
      cancelToken: source.token,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        const rows = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
            ? res
            : [];
        this.setState({
          loader: false,
          itemPagination: {
            ...(typeof res === "object" && !Array.isArray(res) ? res : {}),
            items: rows,
            data: rows,
            page: res?.page || page,
            total: res?.total || rows.length,
            hasNext: !!res?.hasNext,
            pageSize: res?.pageSize || perPage,
          },
          currentPage: res?.page || page,
        });
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  };

  checkFloteNumber = (n) => Number(n) === n && n % 1 !== 0;

  setPagination = (user) => {
    const { itemPagination } = this.state;
    if (itemPagination?.items?.length) {
      const nUser = { ...user };
      let lastPage = nUser.total / this.state.pagesize;
      const isFloat = this.checkFloteNumber(lastPage);
      delete nUser.data;
      nUser.pageSize = this.state.pagesize;
      nUser.lastPage = isFloat ? parseInt(lastPage + 1, 10) : lastPage;
      return nUser;
    }
    return {};
  };

  handleChangeRowsPerPage = (value) => {
    if (source) source.cancel();
    this.setState({ pagesize: value, currentPage: 1 }, () => {
      this.fetchData(1, this.state.pagesize);
    });
  };

  handleChangePage = (value) => {
    if (source) source.cancel();
    this.setState({ currentPage: value }, () => {
      this.fetchData(this.state.currentPage, this.state.pagesize);
    });
  };

  handleFilterChange = (name, value) => {
    this.setState({ [name]: value });
  };

  applyFilters = () => {
    this.setState({ currentPage: 1 }, () => {
      this.fetchData(1, this.state.pagesize);
    });
  };

  clearFilters = () => {
    this.setState({ paymentNumber: "", refNumber: "", currentPage: 1 }, () => {
      this.fetchData(1, this.state.pagesize);
    });
  };

  downloadPaymentPdf = (item) => {
    // Match admin: open customer receiving MUI doc with autoPrint
    try {
      printCustomerReceivingPdf(item, {
        logInUser: this.props.logInUser,
      });
    } catch (error) {
      console.log("er =", error);
      this.props.dispatch(notifyError("somethingWentWrong"));
    }
  };

  getRowDefinition = () => {
    // const garagePayments = !!this.props.garagePayments;
    return [
      {
        id: "paymentNumber",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("paymentNumber"),
      },
      {
        id: "invoiceNumbers",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("invoiceNumbers"),
      },
      {
        id: "refNum",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("refNum"),
      },
      {
        id: "paymentMode",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("paymentMode"),
      },
      // {
      //   id: garagePayments ? "garageName" : "customerName",
      //   numeric: false,
      //   disablePadding: false,
      //   label: this.props.translate(
      //     garagePayments ? "garageName" : "customerName",
      //   ),
      // },
      {
        id: "amount",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("amount"),
      },
      {
        id: "paymentDate",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("paymentDate"),
      },
      {
        id: "adjustmentType",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("adjustmentType"),
      },
      {
        id: "recipientDate",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("recipientDate"),
        hide: false,
      },
      {
        id: "paymentPdf",
        label: this.props.translate("payment"),
      },
    ];
  };

  render() {
    if (!this.props.logInUser) return null;

    const { mode } = this.state;

    return (
      <Layout
        {...this.props}
        {...this.state}
        submitSideBarSearch={this.submitSideBarSearch}
        downloadInvoice={this.downloadInvoice}
      >
        <div className="main-content-page">
          <div
            style={{
              background: this.props.themecolors.backgroundColor,
              color: this.props.themecolors.textColor,
              borderRadius: 6,
              padding: 10,
            }}
          >
            {mode === "create" ? (
              <AddPaymentForm
                translate={this.props.translate}
                dispatch={this.props.dispatch}
                logInUser={this.props.logInUser}
                ServerSetting={this.props.ServerSetting}
                onCancel={this.closeForm}
                onSuccess={this.handleCreateSuccess}
              />
            ) : (
              <>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={12} sm={3} md={2}>
                    <h3 style={{ margin: 0 }}>
                      {this.props.translate("payments")}
                    </h3>
                  </Grid>
                  <Grid item xs={12} sm={3} md={2}>
                    <TextField
                      fullWidth
                      margin="dense"
                      variant="outlined"
                      label={this.props.translate("paymentNumber")}
                      value={this.state.paymentNumber}
                      onChange={(e) =>
                        this.handleFilterChange("paymentNumber", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={2}>
                    <TextField
                      fullWidth
                      margin="dense"
                      variant="outlined"
                      label={this.props.translate("refNumber")}
                      value={this.state.refNumber}
                      onChange={(e) =>
                        this.handleFilterChange("refNumber", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={6}>
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        marginTop: 4,
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          marginTop: 4,
                          flexWrap: "wrap",
                        }}
                      >
                        <Button size="small" onClick={this.applyFilters}>
                          {this.props.translate("sharedSearch") ||
                            this.props.translate("search") ||
                            "Search"}
                        </Button>
                        <Button size="small" onClick={this.clearFilters}>
                          {this.props.translate("clear") ||
                            this.props.translate("sharedClear") ||
                            "Clear"}
                        </Button>
                      </div>
                      {checkPrivileges("paymentCreate") && (
                        <Button size="small" onClick={this.openCreateForm}>
                          {this.props.translate("addPayment") ||
                            this.props.translate("sharedCreate") ||
                            "Add Payment"}
                        </Button>
                      )}
                    </div>
                  </Grid>
                </Grid>

                <Grid container style={{ marginTop: 10 }}>
                  <Grid item xs={12}>
                    {this.state.loader ? (
                      <Loader />
                    ) : (
                      <Table
                        rows={
                          (this.state.itemPagination &&
                            this.state.itemPagination.items) ||
                          []
                        }
                        pagination={this.setPagination(
                          this.state.itemPagination,
                        )}
                        payments
                        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                        handleChangePage={this.handleChangePage}
                        logInUser={this.props.logInUser}
                        themecolors={this.props.themecolors}
                        translate={this.props.translate}
                        ServerSetting={this.props.ServerSetting}
                        downloadInvoicePdf={this.downloadPaymentPdf}
                        rowDefinition={this.getRowDefinition()}
                      />
                    )}
                  </Grid>
                </Grid>
              </>
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
  logInUser: state.logInUsers,
  ServerSetting: state.ServerSetting,
});

export default connect(mapStateToProps)(withTranslationWrapper(Payments));
